import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AppSvgIconComponent } from '@vallift/ngl';

@Component({
  selector: 'app-home-hero-section',
  imports: [RouterLink, AppSvgIconComponent],
  templateUrl: './home-hero-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class HomeHeroSectionComponent {
  readonly previewScale = input.required<number>();
}

